import { useEffect, useState } from 'react';
import { getAssignedFields } from 'common/components/Filters/CustomFieldsFilter/customFields.utils';

import { useEnabledCustomFieldQuery } from 'admin/customFields/hooks/useEnabledCustomFieldQuery';
import {
  CustomFieldProp,
  AssignedCustomField,
} from 'src/admin/customFields/entities/customFields.entity';

export const useSimCustomFields = (customFields?: CustomFieldProp[]) => {
  const { data: customFieldsData } = useEnabledCustomFieldQuery();

  const clearCustomFields = () => {
    setAssignedCustomFields(getAssignedFields(customFields || [], customFieldsData || []));
  };

  const [assignedCustomFields, setAssignedCustomFields] = useState<AssignedCustomField[]>([]);
  const originalCustomFields = getAssignedFields(customFields || [], customFieldsData || []);

  useEffect(() => {
    if (customFieldsData) {
      setAssignedCustomFields(getAssignedFields(customFields || [], customFieldsData || []));
    }
  }, [customFieldsData, customFields]);

  return {
    customFieldsData,
    assignedCustomFields,
    originalCustomFields,
    setAssignedCustomFields,
    clearCustomFields,
  };
};
